import {
    Bill,
    Box,
    Briefcase,
    Cards,
  Clock,
    Home,
    Money,
    MoneyRecive,
    Moneys,
    MoneySend,
    MoneyTime,
    Profile2User,
    Receipt,
    Receipt2,
    ReceiptText,
    Strongbox,
  Truck,
    Wallet,
} from "iconsax-reactjs";

import NGNCurrency from "../asset/images/Currency.svg";
import EUCurrency from "../asset/images/EU.svg";
import US from "../asset/images/US.png";
import GBPCurrency from "../asset/images/GB.svg";
import { TourContentChild } from "component/finance/FinanceTourContentComponent";
import { PieChart } from "lucide-react";

export const EMAIL_REGEX = /^\w+(\+[\w]+)?([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;

export const isCrypto = (currency) => ['USDC', 'USDT'].includes(currency)

export const CRYPTO_NETWORKS = ["POLYGON", "BASE", "TRON", "ETHEREUM"]

export const SEND_MONEY = "SEND_MONEY";
export const SUMMARY = "SUMMARY";
export const SEND_MONEY_STEP_TWO = "SEND_MONEY_STEP_TWO";

export const DEFAULT_RATE = "0.000000";

export const SHOW_COUNTRY_FLAG = {
    NGN: NGNCurrency,
    EUR: EUCurrency,
    USD: US,
    GBP: GBPCurrency,
};

export const ADD_ITEM_DETAILS = "ADD_ITEM_DETAILS";
export const ADD_SHIPMENT_DETAILS = "ADD_SHIPMENT_DETAILS";
export const ADD_PAYMENT_INFO = "ADD_PAYMENT_INFO";
export const ADD_RECEIVER_INFO = "ADD_RECEIVER_INFO";
export const SHIPMENT_SUMMARY = "SHIPMENT_SUMMARY";

export const optionalCostList = [
    { label: "Shipping Fee", value: "ShippingFee" },
    { label: "Handling Fee", value: "handlingFee" },
    { label: "Insurance", value: "insurance" },
    { label: "Packaging/Repackaging Fee", value: "packagingFee" },
    { label: "Warehousing Fee", value: "warehouseFee" },
    { label: "Tax and duty", value: "taxAndDuty" },
    { label: "Miscellaneous Fee", value: "miscellaneousFee" },
];

export const paymentInfoOptions = [
    { label: "Payment before shipment", value: "PaymentBeforeShipment" },
    { label: "Payment on delivery", value: "PaymentOnDelivery" },
    { label: "Split payment", value: "SplitPayment" },
];

export const financeStatus = {
  Soon: {
    bgColor: "#F3F4FB",
    borderColor: "",
    textColor: "#494E6E",
    text: "Coming Soon",
  },
    Processing: {
        bgColor: "#DCFDDB",
        borderColor: "#83F382",
        textColor: "#11A811",
        text: "Processing",
    },
  pending: {
      bgColor: "#FFEFC6",
      borderColor: "#FEC74B",
      textColor: "#B64607",
      text: "Pending",
    },
    PENDING: {
      bgColor: "#FFEFC6",
      borderColor: "#FEC74B",
      textColor: "#B64607",
        text: "Pending",
    },
    Disbursed: {
        bgColor: "#FFEFC6",
        textColor: "#B64607",
        text: "Disbursed",
        borderColor: "#FEC74B",
    },
    accepted: {
        bgColor: "#FFEFC6",
        textColor: "#B64607",
        text: "Accepted",
        borderColor: "#FEC74B",
    },
    disbursed: {
        bgColor: "#DCFDDB",
        borderColor: "#83F382",
        textColor: "#11A811",
        text: "Disbursed",
    },
    approved: {
        bgColor: "#DCFDDB",
        borderColor: "#83F382",
        textColor: "#11A811",
        text: "Approved",
    },
    CONFIRMED: {
        bgColor: "#DCFDDB",
        borderColor: "#83F382",
        textColor: "#11A811",
        text: "Confirmed",
    },
    repaid: {
        bgColor: "#DCFDDB",
        borderColor: "#83F382",
        textColor: "#11A811",
        text: "Repaid",
    },
    Expired: {
        bgColor: "#FFE1E1",
        textColor: "#F73C3C",
        text: "Expired",
        borderColor: "#FFA1A1",
    },
    rejected: {
        bgColor: "#FFE1E1",
        textColor: "#F73C3C",
        text: "Rejected",
        borderColor: "#FFA1A1",
    },
  REJECT: {
    bgColor: "#FFE1E1",
    textColor: "#F73C3C",
    text: "Rejected",
    borderColor: "#FFA1A1",
  },
    cancelled: {
        bgColor: "#FFE1E1",
        textColor: "#F73C3C",
        text: "Cancelled",
        borderColor: "#FFA1A1",
    },
    draft: {
        bgColor: "#F3F4FB",
        textColor: "#475467",
        text: "Draft",
        borderColor: "#E1E3F4",
    },
    Draft: {
        bgColor: "#F3F4FB",
        textColor: "#475467",
        text: "Draft",
        borderColor: "#E1E3F4",
    },
};

export const shipmentStatus = {
    NotStarted: { bgColor: "#FFEFC6", textColor: "#B64607", text: "Not Started" },
    UNPAID: { bgColor: "#FFEFC6", textColor: "#B64607", text: "Unpaid" },
    InProgress: { bgColor: "#EBE4FF", textColor: "#5E01D6", text: "In Progress" },
    PickedUp: { bgColor: "#EBE4FF", textColor: "#5E01D6", text: "Picked Up" },
    Unpaid: { bgColor: "#EBE4FF", textColor: "#5E01D6", text: "Unpaid" },
    pending: { bgColor: "#EBE4FF", textColor: "#5E01D6", text: "Pending" },
    Cancelled: {
        bgColor: "#FFE1E1",
        textColor: "#C01515",
        text: "Canceled",
    },
    Overdue: {
        bgColor: "#FFE1E1",
        textColor: "#C01515",
        text: "Overdue",
    },
    DUE: {
        bgColor: "#FFE1E1",
        textColor: "#C01515",
        text: "Overdue",
    },
    REJECTED: {
        bgColor: "#FFE1E1",
        textColor: "#C01515",
        text: "Rejected",
    },
    REJCTED: {
        bgColor: "#FFE1E1",
        textColor: "#C01515",
        text: "Rejected",
    },
    Delayed: {
        bgColor: "#FFE1E1",
        textColor: "#C01515",
        text: "Delayed",
    },
    AtDeparturePort: { bgColor: "#DCFDDB", textColor: "#107C10", text: "At departure port" },
    AtDestinationPort: { bgColor: "#DCFDDB", textColor: "#107C10", text: "At destination port" },
    Completed: { bgColor: "#DCFDDB", textColor: "#107C10", text: "Completed" },
    Disbursed: { bgColor: "#DCFDDB", textColor: "#11A811", text: "Disbursed" },
    Processing: {
        bgColor: "#FFEFC6",
        textColor: "#B64607",
        borderColor: "#FEC74B",
        text: "Processing",
    },
    Delivered: { bgColor: "#DCFDDB", textColor: "#107C10", text: "Delivered" },
    PAID: { bgColor: "#DCFDDB", textColor: "#107C10", text: "Paid" },
    Paid: { bgColor: "#DCFDDB", textColor: "#107C10", text: "Paid" },
    Draft: { bgColor: "#DBDFE5", textColor: "#475467", text: "Draft" },
    DRAFT: { bgColor: "#DBDFE5", textColor: "#475467", text: "Draft" },
};

export const shipmentStatusList = [
    { label: "Picked up", value: "PickedUp" },
    {
        label: "At departure port",
        value: "AtDeparturePort",
    },
    {
        label: "At destination port",
        value: "AtDestinationPort",
    },
    { label: "Delivered", value: "Delivered" },
    { label: "Delayed", value: "Delayed" },
    { label: "Cancelled", value: "Cancelled" },
];

export const shipmentLoadType = [
    "Full Container Load (FCL)",
    "Less than Container Load (LCL)",
    "Full Truckload (FTL)",
    "Less than Truckload (LTL)",
];

export const shipmentContainerType = [
    "20 Foot",
    "40 Foot",
    "40-Foot High Cube",
    "45-Foot High Cube",
];
export const shipmentPackageType = [
    "Carton/Box",
    "Crate",
    "Pallet",
    "Bag/Sack",
    "Bundle",
    "Container/Loose",
];

export const SOCKET_EVENTS = {
    CREATE_CONVERSATION: "create_conversation",
    SEND_MESSAGE: "send_message",
    GET_MESSAGES: "get_messages",
    GET_ONE_MESSAGE: "get_one_message",
    GET_MESSAGE_COUNT: "count_messages",
    READ_MESSAGE: "read_messages",
    GET_CONVERSATIONS: "get_conversations",
    GET_ONE_CONVERSATION: "get_one_conversation",
    ERROR: "error",
    SUBSCRIBE_OPENING_FEE_STATUS: "subscribeOpeningFeeStatus",
};

export const SOCKET_LISTENERS = {
    CONVERSATION_CREATED: "conversation_created",
    MESSAGE_SENT: "message_sent",
    FETCH_MESSAGES: "messages_fetched",
    FETCH_ONE_MESSAGE: "one_message_fetched",
    MESSAGE_COUNT: "messages_counted",
    MESSAGES_READ: "messages_read",
    CONVERSATION_FETCHED: "conversations_fetched",
    FETCH_ONE_CONVERSATION: "one_conversation_fetched",
    ERROR: "error",
    OPENING_FEE_STATUS_UPDATED: "openingFeeStatusUpdated",
};
export const shippingType = {
    SeaFreight: "Sea Freight",
    Trucking: "Trucking",
    "Sea Freight": "Sea Freight",
    "Sea freight": "Sea Freight",
    Truck: "Trucking",
};

export const newDashboardListOfLinks = {
    FIRST: [
        {
            text: "Home",
            link: "/dashboard",
            icon: (variant, color) => <Home size={20} variant={variant} color={color} />,
        },
    ],
    PAY: [
        {
            text: "Wallets",
            link: "/wallets",
            icon: (variant, color) => <Wallet size={20} variant={variant} color={color} />,
        },
        {
            text: "Bill Payments",
            link: "/bill-payments",
            icon: (variant, color) => <Bill size={20} variant={variant} color={color} />,
        },
        {
            text: "Invoices",
            link: "/invoice",
            icon: (variant, color) => <Receipt size={20} variant={variant} color={color} />,
        },
        {
            text: "Corporate Cards",
            link: "/corporate-cards",
            icon: (variant, color) => <Cards size={20} variant={variant} color={color} />,
            comingSoon: true,
        },
    ],
    FINANCE: [
        // {
        //     text: "Loan",
        //     link: "/finance/home?tab=Instruments",
        //     icon: (variant, color) => <Moneys size={20} variant={variant} color={color} />,
        // },
        // {
        //     text: "Loan History",
        //     link: "/finance/history?tab=History",
        //     icon: (variant, color) => <MoneyTime size={20} variant={variant} color={color} />,
        // },
        {
            text: "Credit",
            // link: "/finance/credit/request",
            link: "/finance/credit",
            icon: (variant, color) => <Moneys size={20} variant={variant} color={color} />,
        },
        {
            text: "History",
            link: "/finance/credit/history",
            icon: (variant, color) => <MoneyTime size={20} variant={variant} color={color} />,
        },
    ],
    FLEX: [
        {
            text: "Procurement",
            link: "/flex/home",
            icon: (variant, color) => <Receipt2 size={20} variant={variant} color={color} />,
            children: [
                {
                    text: "Shipments",
                    link: "/flex/home/shipments",
                },
            ],
        },
        // {
        //     text: "Shipment",
        //     link: "/flex/home/shipments",
        //     icon: (variant, color) => <Box size={20} variant={variant} color={color} />,
        // },
        {
            text: "Network",
            link: "/flex/home/network",
            icon: (variant, color) => <Profile2User size={20} variant={variant} color={color} />,
        },
    ],
    CAPITAL: [
        {
            text: "Portfolio",
            link: "/capital/home",
            icon: (variant, color) => <Briefcase size={20} variant={variant} color={color} />,
            comingSoon: true,
        },
        {
            text: "Buy",
            link: "/capital/buy",
            icon: (variant, color) => <MoneySend size={20} variant={variant} color={color} />,
            comingSoon: true,
        },
        {
            text: "Sell",
            link: "/capital/sell",
            icon: (variant, color) => <MoneyRecive size={20} variant={variant} color={color} />,
            comingSoon: true,
        },
        {
            text: "Vault",
            link: "/capital/otc-desk",
            icon: (variant, color) => <Strongbox size={20} variant={variant} color={color} />,
            comingSoon: true,
        },
    ],
};

export const sortByTimeFrame = [
    { text: "All time", value: "all" },
    { text: "Past 1 year", value: "1y" },
    { text: "Past 1 month", value: "1m" },
    { text: "Past 1 week", value: "1w" },
    { text: "Past 24 hours", value: "24h" },
];
export const sortByFilter = [
    { text: "Newest first", value: "newest-first" },
    { text: "Oldest first", value: "oldest-first" },
    { text: "Earliest due date", value: "earliest-due-date" },
    { text: "Latest due date", value: "latest-due-date" },
    { text: "Price: Low - High", value: "price-low-high" },
    { text: "Price: High - Low", value: "price-high-low" },
    { text: "Items: Least - Most", value: "items-least-most" },
    { text: "Items: Most - Least", value: "items-most-least" },
];

export const statusFilterTabs = [
    { text: "All", value: "ALL" },
    { text: "Unpaid", value: "UNPAID" },
    { text: "Overdue", value: "DUE" },
    { text: "Paid", value: "PAID" },
    { text: "Draft", value: "DRAFT" },
];
export const sortByStatus = ["Paid", "Unpaid", "Overview"];

export const ShipmentTableHeader = [
    { title: "Invoice number", width: "160px" },
    { title: "Amount", width: "160px" },
    { title: "Customer", width: "280px" },
    { title: "Status", width: "160px" },
    { title: "Issued", width: "190px" },
    { title: "Due", width: "200px" },
];

export const LoanHistoryTableHeader = [
    { title: "Request Date", width: "260px" },
    { title: "Loan amount", width: "260px" },
    { title: "Loan Type", width: "280px" },
    { title: "Status", width: "350px" },
];

export const invoiceCsvHeaders = [
    { label: "Invoice number", key: "invoiceNumber" },
    { label: "Amount", key: "amount" },
    { label: "Customer", key: "customer" },
    { label: "Status", key: "status" },
    { label: "Issued", key: "issued" },
    { label: "Due", key: "due" },
];

export const invoiceTabType = ["Outgoing", "Incoming"];
export const MAX_IMAGE_FILE_SIZE = 5 * 1024 * 1024; // 5MB limit

export const financeOptions = [
    {
        id: "Payables",
        title: "Payables finance",
        description: "Get paid upfront to fulfil your active orders and transactions",
        icon: <ReceiptText className="w-5 h-5 text-gray-900" />,
        key: "payable_finance",
    },
    {
        id: "Receivables",
        title: "Receivables finance",
        description: "Get paid upfront for your active or due invoices",
        icon: <Money className="w-5 h-5 text-gray-900" />,
        key: "receivable_finance",
    },
  {
    id: "PaymentFinance",
    title: "Payment finance",
    description: "Get funds for time-sensitive cross-border payments",
    icon: <Clock className="w-5 h-5 text-gray-900" />,
    key: "payment_finance",
  },
  {
    id: "AssetPaymentFinance",
    title: "Asset Finance (Fleet by Tradevu)",
    description: "Get funds to acquire logistics and trade-enabling assets",
    icon: <Truck className="w-5 h-5 text-gray-900" />,
    key: "asset_payment_finance",
    isComingSoon: true
  },
  {
    id: "MarginLanding",
    title: "Margin Lending",
    description: "Loans for futures, options, and commodity derivatives trading",
    icon: <PieChart className="w-5 h-5 text-gray-900" />,
    key: "margin_lending_finance",
    isComingSoon: true
  },

];

export const checkFinanceOption = (financeTitle) => {
  const financeOption = financeOptions.find((option) => option?.title === financeTitle);
  return financeOption?.title;
}

export const paymentFinanceList = [
    { text: "All", value: "All" },
    { text: "Completed", value: "Completed" },
    { text: "Cancelled", value: "Cancelled" },
    { text: "Rejected", value: "Rejected" },
];
export const financeDocumentTypes = {
    bankStatement: "Bank Statement",
    boardResolution: "Board resolution to request finance",
};

export const buyBackPeriodList = ["7 days", "15 days", "30 days"];
export const productCategoryList = {
    "Agro-Commodities": [
        "Hibiscus Flower",
        "Palm Kernnel Shells",
        "Cocoa Bean Husk",
        "Shea Nut",
        "Sesame Seeds",
    ],
    "Minerals and REE": [
        "Limestone",
        "Lithium",
        "Bauxite",
        "Neodymium",
        "Muscovite Mica",
        "Praseodymium",
    ],
    "Specialty Materials": ["Mechanical Parts and Wiring"],
};

export const financeDropdownOptions = ({
    finance,
    handleCancelFinance,
    handleMakeRepaymentModal,
    goTo,
    deleteFinance,
}) => {
    if (finance?.status === "pending" || finance?.status === "PENDING") {
        return [
            {
                label: "Cancel request",
                value: "send-money",
                className:
                    "flex items-center gap-2 w-full px-4 py-[9px] hover:bg-main-grey/10 hover:rounded-xl font-light text-sm text-[#101828]",
                action: async () => handleCancelFinance(finance?._id),
            },
        ];
    } else if (finance?.status === "due") {
        return [];
    } else if (finance?.status === "draft") {
        return [
            {
                label: "Continue request",
                value: "send-money",
                className:
                    "flex items-center gap-2 w-full px-4 py-[9px] hover:bg-main-grey/10 hover:rounded-xl font-light text-sm text-[#101828]",
                action: async () => goTo("/finance/credit/request"),
            },
            {
                label: "Delete finance",
                value: "delete-money",
                className:
                    "flex items-center gap-2 w-full px-4 py-[9px] hover:bg-main-grey/10 hover:rounded-xl font-light text-sm text-[#101828]",
                action: async () => deleteFinance(finance?._id),
            },
        ];
        // } else if (finance?.status === "disbursed" && finance?.loans?.paymentStatus !== "REPAID") {
    } else if (finance?.status === "disbursed" || finance?.status === "accept") {
        return [
            {
                label: "Make a repayment",
                value: "send-money",
                className:
                    "flex items-center gap-2 w-full px-4 py-[9px] hover:bg-main-grey/10 hover:rounded-xl font-light text-sm text-[#101828]",
                action: async () => handleMakeRepaymentModal(finance),
            },
        ];
    }
    // else if (finance?.status === "cancelled") {
    //     return [
    //         {
    //             label: "Delete finance",
    //             value: "delete-money",
    //             className:
    //                 "flex items-center gap-2 w-full px-4 py-[9px] hover:bg-main-grey/10 hover:rounded-xl font-light text-sm text-[#101828]",
    //             action: async () => deleteFinance(finance?._id),
    //         },
    //     ];
    // }
    else {
        return [];
    }
};

export const paymentTypeForPayload = {
    Invoice: "invoice",
    "Purchase order": "purchase_order",
    Transaction: "transaction",
    Freight: "freight_payment",
    Other: "other",
};

export const reversePaymentType = {
    invoice: "Invoice",
    purchase_order: "Purchase order",
    transaction: "Transaction",
    freight_payment: "Freight",
    other: "Other",
};

export const tourSteps = [
    {
        selector: ".first-step",
        content: (props) => (
            <TourContentChild
                {...props}
                title="Navigate credit"
                content={() => (
                    <span className="text-sm text-secondary-40">
                        <span className="font-medium">Credit</span> handles everything that’s active
                        and <br /> <span className="font-medium">history</span> handles everything
                        else
                    </span>
                )}
            />
        ),
    },
    {
        selector: ".second-step",
        content: (props) => (
            <TourContentChild
                {...props}
                title="Request for finance"
                content="Get a loan for your payable, receivable or inventory needs"
            />
        ),
    },
    {
        selector: ".third-step",
        content: (props) => (
            <TourContentChild
                {...props}
                title="Meet your credit wallet"
                content="Loan funds are disbursed here so you can make payments for invoices,
                        purchase orders, freights and transactions"
            />
        ),
    },
    {
        selector: ".fourth-step",
        content: (props) => (
            <TourContentChild
                {...props}
                title="Pay with credit"
                content={
                    "Use your loan funds to pay for invoices, purchase orders, freights or transactions"
                }
            />
        ),
    },
    {
        selector: ".fifth-step",
        content: (props) => (
            <TourContentChild
                {...props}
                title="Manage your loans"
                content={"Track your requests to disbursal and make repayments"}
            />
        ),
    },
    {
        selector: ".sixth-step",
        content: (props) => (
            <TourContentChild
                {...props}
                title="Track your payments"
                content={
                    "Manage payments for invoice, purchase order, freight and transaction from the credit wallet."
                }
            />
        ),
    },
    {
        selector: ".seventh-step",
        content: (props) => (
            <TourContentChild
                {...props}
                title="Keep your documents up to date"
                content={
                    "Upload and manage essential documents required to process your loan requests"
                }
            />
        ),
    },
];

export const financeTypeForDate = {
    pending: "Requested on",
    disbursed: "Payment due on",
    due: "Payment due on",
    draft: "Created on",
    approved: "Approved on",
    rejected: "Rejected on",
};
